<template>
  <div
    :id="blockId"
    class="element-editor shape-editor"
    :style="blockStyle"
  >
    <div class="shape" :style="style">
    </div>
  </div>
</template>

<script>
import presets from './shapes'

export default {
  name: 'ShapeEditor',
  props: {
    shape: {
      type: String,
      default: 'Rectangle',
    },
    blockId: {
      type: String,
      default: null,
    },
    blockStyle: {
      type: Object,
      default: null,
    },
    shapeStyle: {
      type: Object,
      default: null,
    },
  },
  computed: {
    style() {
      let css = {}

      if (presets[this.shape]) {
        css['clip-path'] = presets[this.shape].value
      }

      if (this.shapeStyle) {
        css = {
          ...css,
          ...this.shapeStyle,
        }
      }

      return css
    },
  },
  mounted() {
    this.$nextTick(() => { this.$emit('ready') })
  },
}
</script>

<style lang="scss" scoped>
.shape {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  touch-action: pan-x pan-y pinch-zoom;
}
</style>
